/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { ArchivesDaoService } from '../archives-dao.service';
import { Archive } from 'src/app/_model/archive';

// CONSTANTS
const ACTIVITYTYPES_KEY = 'archives';

@Injectable()
export class ArchivesStorageDaoService implements ArchivesDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveArchives(archives: Archive[]): Promise<void> {
    return this.keyValueStorage.store(ACTIVITYTYPES_KEY, archives);
  }
  public getArchives(): Promise<Archive[]> {
    return this.keyValueStorage.load(ACTIVITYTYPES_KEY);
  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(ACTIVITYTYPES_KEY);
  }
}
